import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updatePickSessionFilter = {
  name: "updatePickSessionFilter" as const,
  input: z.object({
    id: zExt.objectId(),
    name: z.string(),
    filters: z.array(AdvancedFilterDataSchema),
  }),
  output: z.object({ success: z.boolean() }),
};
